import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from '@betty/toolkit/state';
import {
  selectRegistrationFormPromoId,
  selectRegistrationOffer,
} from '../../state';
import RegistrationOfferImage from '../RegistrationOfferImage/RegistrationOfferImage';
import { Box, Button, Text } from '@betty/moonlight';
import { Linking } from 'react-native';
import RegistrationNavigationHeader from '../RegistrationProgressHeader/RegistrationNavigationHeader/RegistrationNavigationHeader';
import { useTranslation } from '@betty/i18n';

function RegistrationFailed() {
  const { t } = useTranslation('registration');
  const offerId = useSelector(selectRegistrationFormPromoId) || -1;
  const offer = useSelector(selectRegistrationOffer(offerId));
  const rewards = useMemo(() => offer?.rewards || [], [offer?.rewards]);
  const emailUsHandler = useCallback(() => {
    Linking.openURL(
      encodeURI(`mailto:welcome@betty.ca?subject=ID Verification Documents`),
    );
  }, []);

  if (!offer) {
    return null;
  }

  return (
    <Box flex={1}>
      <RegistrationNavigationHeader
        options={{ title: t('createBettyAccount') }}
      />
      <Box flex={1} justifyContent="center">
        <Box justifyContent="center" alignItems="center">
          <RegistrationOfferImage
            width={240}
            height={240}
            rewards={rewards}
            miniImageUrl={offer?.miniImageUrl || ''}
          />
        </Box>
        <Box
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          marginTop="space-400"
        >
          <Text
            variant="h4"
            locNS="registration"
            locKey="registrationFailedTitle"
            color="darkSurfaceTertiary"
            textAlign="center"
            width="100%"
            marginBottom="space-200"
          />
          <Text
            variant="body-l"
            locNS="registration"
            locKey="registrationFailedBody"
            color="darkSurfaceTertiary"
            textAlign="center"
            width="100%"
          />
          <Box width="100%" paddingLeft="space-600">
            <Box width="100%" marginTop="space-300">
              <Text
                variant="body-s"
                locNS="registration"
                locKey="registrationFailedDocumentOneLabel"
                color="darkSurfaceTertiary"
                textAlign="left"
              />
            </Box>
            <Box width="100%" marginTop="space-100">
              <Text
                variant="body-s"
                locNS="registration"
                locKey="registrationFailedDocumentTwoLabel"
                color="darkSurfaceTertiary"
                textAlign="left"
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        paddingHorizontal="space-400"
        marginBottom="space-200"
        paddingBottom="safe-area-inset-bottom"
      >
        <Button
          position="relative"
          variant="primary"
          locKey="emailUsButton"
          locNS="registration"
          onPress={emailUsHandler}
          size="large"
          width="100%"
        />
      </Box>
    </Box>
  );
}

export default memo(RegistrationFailed);
